import { ConnectionLayout } from 'components/login/ConnectionLayout';
import React from 'react';

import { PrimaryButtonV2 } from '@fragment/ui/src/components/Button/PrimaryButtonV2/PrimaryButtonV2';

export const WorkspaceNotFound = (): JSX.Element => (
  <ConnectionLayout title="Workspace Not Found">
    <div className="space-y-f4">
      <p>This workspace could not be found or you do not have access to it.</p>
      <PrimaryButtonV2
        className="px-[1ch] py-fhalf"
        onClick={() => window.location.assign('/')}
      >
        Back to Dashboard
      </PrimaryButtonV2>
    </div>
  </ConnectionLayout>
);
